import {
  GET_WISE_STOCK_REPORT_REQUEST,
  GET_WISE_STOCK_REPORT_SUCCESS,
  GET_WISE_STOCK_REPORT_ERROR,
  GET_STYLE_WISE_STOCK_REPORT_REQUEST,
  GET_STYLE_WISE_STOCK_REPORT_SUCCESS,
  GET_STYLE_WISE_STOCK_REPORT_ERROR,
  GET_NEGATIVE_OTS_ORDER_WISE_REQUEST,
  GET_NEGATIVE_OTS_ORDER_WISE_SUCCESS,
  GET_NEGATIVE_OTS_ORDER_WISE_ERROR,
  GET_SHIPPED_STYLE_WISE_PERCENTAGE_REPORT_ERROR,
  GET_SHIPPED_STYLE_WISE_PERCENTAGE_REPORT_SUCCESS,
  GET_SHIPPED_STYLE_WISE_PERCENTAGE_REPORT_REQUEST,
  GET_PRODUCTION_SKU_WISE_PERCENTAGE_REPORT_REQUEST,
  GET_PRODUCTION_SKU_WISE_PERCENTAGE_REPORT_SUCCESS,
  GET_PRODUCTION_SKU_WISE_PERCENTAGE_REPORT_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getWise_Stock_Report = (token, values) => (dispatch) => {
  dispatch({ type: GET_WISE_STOCK_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/styleWiseStockReportPk`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { ...values },
  })
    .then((response) => {
      return dispatch({
        type: GET_WISE_STOCK_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_WISE_STOCK_REPORT_ERROR,
        payload: [],
      });










    });
};

export const getNegativeOtsOrderWise = (token, values) => (dispatch) => {
  dispatch({ type: GET_NEGATIVE_OTS_ORDER_WISE_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/negativeOtsOrderWise`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { ...values },
  })
    .then((response) => {
      return dispatch({
        type: GET_NEGATIVE_OTS_ORDER_WISE_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_NEGATIVE_OTS_ORDER_WISE_ERROR,
        payload: [],
      });
    });
};

export const getStyleWiseStockReport = (token, values) => (dispatch) => {
  dispatch({ type: GET_STYLE_WISE_STOCK_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/getStyleWiseStockReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { ...values },
  })
    .then((response) => {
      return dispatch({
        type: GET_STYLE_WISE_STOCK_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_STYLE_WISE_STOCK_REPORT_ERROR,
        payload: [],
      });
    });
};

export const getShippedStyleWisePercentageReport = (token, data, status, ptStatus) => (dispatch) => {
  dispatch({ type: GET_SHIPPED_STYLE_WISE_PERCENTAGE_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/ShippedStyleWisePercentage`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      customer_id: (data.customer === "All" || data.customer === undefined) ? null : data.customer,
      status_id: status.length > 0 ? status.toString() : null,
      customer_type_id: ptStatus && ptStatus.length > 0 ? ptStatus.toString() : "2,14,1,3,13",
      region_id: (data.region === "All" || data.region === undefined) ? null : data.region,
      from_date: moment(data?.from_date).format("MM-DD-YYYY"),
      to_date: moment(data?.to_date).format("MM-DD-YYYY"),
      cut_id: (data.cut === "All" || data.cut === undefined) ? null : data.cut,
      gender_id: (data.gender === "All" || data.gender === undefined) ? null : data.gender,
      style_id: (data.style === "All" || data.style === undefined) ? null : data.style,
      sku: (data.sku === "" || data.sku === undefined) ? null : data.sku,
      inseam: (data.inseam === "All" || data.inseam === undefined) ? null : data.inseam,
    }
  })
    .then((response) => {
      return dispatch({
        type: GET_SHIPPED_STYLE_WISE_PERCENTAGE_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SHIPPED_STYLE_WISE_PERCENTAGE_REPORT_ERROR,
        payload: [],
      });
    });
};

export const getProductionSKUWisePercentageReport = (token, data) => (dispatch) => {
  dispatch({ type: GET_PRODUCTION_SKU_WISE_PERCENTAGE_REPORT_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/SizeCurveReportShippedSku`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      from_date: moment(data?.from_date).format("MM-DD-YYYY"),
      to_date: moment(data?.to_date).format("MM-DD-YYYY"),
      style_id: data.style_id === undefined ? null : Number(data.style_id),
    }
  })
    .then((response) => {
      return dispatch({
        type: GET_PRODUCTION_SKU_WISE_PERCENTAGE_REPORT_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_PRODUCTION_SKU_WISE_PERCENTAGE_REPORT_ERROR,
        payload: [],
      });
    });
};